import { TranslateService } from '@ngx-translate/core';

import {
  CODE_VALIDATE_ERRORS,
  HelmsdeepValidateCodeErrorResponse,
} from '../services/helmsdeep/helmsdeep-validate-code-error.response';

import { DISPENSE_STATES } from './constants';
import { isPickupCode, isReclaimCode } from './schedule-codes.utils';

const PICKUP_IN_ANOTHER_DEVICE_MSG = 'common.pickupInAnotherDeviceMsg';
const RECLAIM_IN_ANOTHER_DEVICE_MSG = 'common.reclaimInAnotherDeviceMsg';
const INVALID_CODE_MSG = 'common.invalidCodeMsg';

/** States in which an order has already left the locker, so it can no longer be reclaimed. */
const ALREADY_RECLAIMED_STATES: string[] = [
  DISPENSE_STATES.RECLAIMED,
  DISPENSE_STATES.REMOVED,
  DISPENSE_STATES.DISPENSED,
];

/**
 * Title that ApiErrorHandlerService should render for a failed code validation, or null to keep
 * the one helmsdeep sent. Shared by every screen that validates codes on the client side.
 */
export function resolveValidateCodeErrorTitle(
  error: HelmsdeepValidateCodeErrorResponse,
  code: string,
  translateService: TranslateService
): string | null {
  const codeType = `${error.detail?.codeType}`;

  if (error.message === CODE_VALIDATE_ERRORS.ORDER_ON_ANOTHER_DEVICE) {
    const template = isPickupCode(codeType)
      ? PICKUP_IN_ANOTHER_DEVICE_MSG
      : RECLAIM_IN_ANOTHER_DEVICE_MSG;
    return translateService.instant(template, {
      deviceName: error.detail?.assignedDeviceName,
      codeNumber: code,
    });
  }

  if (error.message !== CODE_VALIDATE_ERRORS.INVALID_STATE) {
    return null;
  }

  const currentState = error.detail?.currentState;

  if (isPickupCode(codeType) && currentState === DISPENSE_STATES.LOCKEDDOWN) {
    return DISPENSE_STATES.LOCKEDDOWN;
  }
  if (isPickupCode(codeType) && currentState === DISPENSE_STATES.LOADED_VERIFY) {
    return DISPENSE_STATES.LOADED_VERIFY;
  }
  if (isReclaimCode(codeType) && ALREADY_RECLAIMED_STATES.includes(`${currentState}`)) {
    return translateService.instant(INVALID_CODE_MSG);
  }

  return null;
}
